import React from "react";
import { Container, Typography, Grid, Card, CardContent, Avatar, Box } from "@mui/material";

const testimonials = [
  {
    avatar: "/jake5.jpg",
    quote: "I've competed on some of the biggest stages in the world, but real estate was a whole new arena for me.  RocketOffer.com game me the coaching and confidence I needed to succeed.  They broke down the plan, showed me how to identify opportunities and backed me with the tools and people to make it happen.  Thanks to their process i found success in real estate.",
    name: "Jake Herbert",
    title: "Olympic Wrestler & Hodge Trophy Winner",
  },
  {
    avatar: "/heidi.jpg",
    quote: "As a house cleaner, I never imagined I could actually flip a house, let alone do it successfully on my first try.  RocketOffer.com made the whole process feel manageable and exciting.  they walked me throught buying the right property and helped me sell it for more than I expected.  I felt like I had a full team behine me every step of the way.",
    name: "Heidi Connock",
    title: "First Time Flipper",
  },
];

const Testimonials = () => {
  return (
        <Box
          sx={{
            backgroundColor: '#181818',
            color: 'white',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: 4,
            px: { xs: 3, sm: 6 },
            py: { xs: 4, sm: 6 },
            mx: 'auto',
            maxWidth: '1000px',
            mb: 6,
            boxShadow: 'inset 0 0 20px rgba(255, 255, 255, 0.1)',
          }}
        >
          <Typography variant="h4" gutterBottom align="center" sx={{ fontWeight: 'bold' }}>
            What Our Users Say
          </Typography>
          <Container sx={{ py: 8 }}>
            <Grid container spacing={4} justifyContent="center">
              {testimonials.map((testimonial, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    <CardContent>
                      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 2 }}>
                        <Avatar
                          src={testimonial.avatar}
                          alt={testimonial.name}
                          sx={{ width: 64, height: 64, mb: 1 }}
                        />
                        <Typography variant="body2" align="center" italic>
                          "{testimonial.quote}"
                        </Typography>
                      </Box>
                      <Typography variant="h6" align="center" color="primary">
                        {testimonial.name}
                      </Typography>
                      <Typography variant="subtitle2" align="center" color="text.secondary">
                        {testimonial.title}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Container>
    </Box>
  );
};

export default Testimonials;
